/* eslint-disable global-require */
module.exports = ['account.stripe.customer.protal.button.m1'];
